// When a record was last updated: modifiedOn, else createdOn (the server orders by the same)
export const lastUpdatedOn = (record) => record.modifiedOn || record.createdOn;
// Who last updated a record: the modifier once modified, else the creator
export const lastUpdatedBy = (record) => (record.modifiedOn ? record.modifiedByName : record.createdByName) || "—";
// Calendar day as local midnight; server dates ("2026-10-21T00:00:00") use their date part, so no timezone shift
export const calendarDay = (value) => {
    if (!value) {
        return null;
    }
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value)) {
        return new Date(Number(value.substring(0, 4)), Number(value.substring(5, 7)) - 1, Number(value.substring(8, 10)));
    }
    const date = value instanceof Date ? value : new Date(value);
    return isNaN(date.getTime()) ? null : new Date(date.getFullYear(), date.getMonth(), date.getDate());
};
// "Recorded on" stamps are stored in UTC without a zone marker - read them as UTC, show them in local time
export const recordedAt = (value) => {
    if (!value) {
        return null;
    }
    const hasZone = /(Z|[+-]\d{2}:?\d{2})$/.test(value);
    const date = new Date(hasZone ? value : value + "Z");
    return isNaN(date.getTime()) ? null : date;
};
export const timeOfDay = (date) => {
    if (!date) {
        return "";
    }
    return `${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
};
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
// History timeline modified date: "27 Oct 2026"
export const historyDate = (value) => {
    const day = calendarDay(value);
    return day ? `${day.getDate()} ${MONTHS[day.getMonth()]} ${day.getFullYear()}` : "";
};
